import { encounterCreatureField, encounterField } from '../../shared/array-types.js';
import { record, upper, type LogRow } from '../ability/context.js';
import { statusCasterId, statusItemId, statusRows } from '../statuses/expiry.js';

type Row = Record<string, unknown>;
/** The encounter roster is installed after spawn acknowledgement. Cache-only actors and floor inventory are not members. */
export function savedAttackMembers(encounter: Row): Map<string, Row> {
  const eid = upper(encounterField(encounter, 'encounter_id'));
  const members = new Map<string, Row>();
  for (const raw of Array.isArray(encounter.encounter_creatures_arr) ? encounter.encounter_creatures_arr : []) {
    const row = record(raw), ec = row?.encounter_creatures;
    const id = upper(encounterCreatureField(ec, 'encounter_creature_id'));
    if (row && id && eid && upper(encounterCreatureField(ec, 'encounter_id')) === eid
      && !Number(encounterCreatureField(ec, 'encounter_creature_deleted') ?? 0)) members.set(id, row);
  }
  return members;
}

/** A departed status source remains the stored caster. Its log uses the saved status holder. */
export function attackStatusParticipants<T extends { rows: LogRow[] }>(effects: T, members: ReadonlyMap<string, Row>): T {
  const rows = effects.rows.map(row => {
    let changed: LogRow | undefined;
    for (const key of ['roll_by', 'roll_to'] as const) {
      const id = upper(row[key]);
      if (!id || members.has(id)) continue;
      const holder = [...members].find(([, member]) => statusRows(member, 'target')
        .some(status => statusCasterId(status) === id && statusItemId(status) === upper(row.roll_item_id)))?.[0];
      if (holder) (changed ??= { ...row })[key] = holder;
    }
    return changed ?? row;
  });
  return rows.some((row, i) => row !== effects.rows[i]) ? { ...effects, rows } : effects;
}
